module.exports = __webpack_public_path__ + "static/media/headerSearch_bg.88d7fe8e.png";